import classNames from 'classnames';
import React, { useMemo } from 'react';

import DetailsListSkeletonItem from './DetailsListSkeletonItem';
import { DetailsListProps } from './types';
import { DetailsListContext } from './useDetailsListContext';

import './DetailsList.scss';

const DetailsList: React.FC<DetailsListProps> = ({
    isLoading = false,
    title,
    wrapperClassName,
    titleClassName,
    separationLines = true,
    className,
    children,
    skeletonCount,
    ...rest
}) => {
    const contextValue = useMemo(() => ({ isLoading }), [isLoading]);
    return (
        <DetailsListContext.Provider value={contextValue}>
            <section className={classNames('sgw-details-list__wrapper', wrapperClassName)}>
                {title && <h2 className={classNames('sgw-details-list__title', titleClassName)}>{title}</h2>}
                <dl
                    className={classNames('sgw-details-list__container', className, {
                        'separation-lines': separationLines,
                    })}
                    {...rest}
                >
                    {isLoading && skeletonCount
                        ? // eslint-disable-next-line react/no-array-index-key
                          Array.from(Array(skeletonCount)).map((_, index) => <DetailsListSkeletonItem key={index} />)
                        : children}
                </dl>
            </section>
        </DetailsListContext.Provider>
    );
};

export default DetailsList;
